import { useTranslation } from "react-i18next";
import "./PhilosophyInfoCard.css";

export default function PhilosophyInfoCard({ title, text, index, total, isActive }) {
  const { t } = useTranslation("translation", { keyPrefix: "ourPhilosophy" });

  return (
    <article
      className="philosophyContentPaper"
      aria-hidden={!isActive}
      aria-label={`${index} / ${total}`}
    >
      <div className="philosophyContentPaper__number">
        <span>{String(index).padStart(2, "0")}</span>
        <span className="philosophyContentPaper__number-divider" />
        <span>{String(total).padStart(2, "0")}</span>
      </div>

      <div className="philosophyContentPaper__content">
        <h3 className="philosophyContentPaper__title">{t(title)}</h3>
        <p className="philosophyContentPaper__text">{t(text)}</p>
      </div>

      <div className="philosophyContentPaper__brand-shape" aria-hidden="true">
        <span className="philosophyContentPaper__brand-strip philosophyContentPaper__brand-strip--accent" />
        <span className="philosophyContentPaper__brand-strip philosophyContentPaper__brand-strip--primary" />
        <span className="philosophyContentPaper__brand-strip philosophyContentPaper__brand-strip--outline" />
        <span className="philosophyContentPaper__brand-strip philosophyContentPaper__brand-strip--small" />
        <span className="philosophyContentPaper__brand-strip philosophyContentPaper__brand-strip--thin" />
      </div>
    </article>
  );
}
